// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__yeRd-","dragIcon":"Choice_dragIcon__1Bo7c","left":"Choice_left__2yBWL","input":"Choice_input__pVzpP"};